// components/ReadyToggle.jsx: M3-14 ready toggle.
//
// Real button (not just a checkbox) so the host/guest get an obvious
// CTA to mark themselves ready between games. Sends SET_READY via the
// hook; the server broadcasts READY_CHANGED which the reducer in
// useRoomWs flips into per-occupant `ready`. The visual indicator on
// each occupant row already exists (see TeamColumns), this
// button is the local user's edit surface.
//
// Visible when the user is in a room AND the room is in the 'waiting'
// phase (between games). Hidden during 'starting'/'in_game' since
// ready is irrelevant once the round is live.

import { useCallback } from 'preact/hooks';
import '../styles/ready-toggle.css';

/**
 * @param {{
 *   ready: boolean,
 *   phase: 'waiting'|'starting'|'in_game',
 *   onToggle: (next: boolean) => void,
 * }} props
 */
export function ReadyToggle({ ready, phase, onToggle }) {
  const handleClick = useCallback(() => {
    onToggle(!ready);
  }, [ready, onToggle]);

  if (phase !== 'waiting') return null;

  return (
    <button
      type="button"
      class={ready ? 'ready-toggle ready' : 'ready-toggle not-ready'}
      data-testid="ready-toggle"
      data-ready={ready ? 'true' : 'false'}
      aria-pressed={ready}
      aria-label={ready ? 'You are ready, mark as not ready' : 'Mark me ready'}
      onClick={handleClick}
    >
      {ready ? '✓ You are ready' : '○ Mark me ready'}
    </button>
  );
}
